<template>
  <div class="spinner-holder">
    <img class="spinner rotating" src="@/assets/img/spinner.png" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
};
</script> 

<style scoped>
.spinner-holder {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.spinner {
  width: 24px;
  height: 24px;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 1s linear infinite;
}
</style>
